import dayjs from 'dayjs';

export function dayjsPipe(i?: string) {
    const date = dayjs(i);
    if (!date.isValid()) return undefined
    return date;
}

export function dayjsPipeFormatted(i?: string, format: string = 'DD/MM/YYYY') {
    if (!i) return undefined;
    // Try parsing as DD/MM/YYYY first, then fallback to default
    let date = dayjs(i, 'DD/MM/YYYY', true);
    if (!date.isValid()) {
        date = dayjs(i);
    }
    if (!date.isValid()) return undefined;
    return date;
}